import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import demoAvatar from 'src/assets/demo/avatar.png';
import { LOGIN_ROUTE, ROOT } from 'src/constants/routes';
import { useAppSelector } from 'src/hooks/store';
import { useTranslation } from 'src/hooks/translations';
import { selectAuth, selectUser } from 'src/store/user/selectors';
import prayersStats from 'src/utils/stats';

import Avatar from '../Avatar';
import Icon from '../Icon';
import LiquidGlassEffect from '../LiquidGlassEffect';
import css from './Header.module.scss';

type Props = {
  avatarUrl?: string;
  points?: number;
  className?: string;
  hideLogo?: boolean;
};

export default function Header({ avatarUrl = demoAvatar, points = 0, className = '', hideLogo = false }: Props) {
  const auth = useAppSelector(selectAuth);
  const user = useAppSelector(selectUser);
  const { translate: _t } = useTranslation('login');

  return (
    <header className={cn(css.header, className, hideLogo && css.logoHidden)}>
      {auth.isLoggedIn ? (
        <div className={css.userInfo}>
          <Avatar className={css.userLink} avatarUrl={user.avatar} />
          <LiquidGlassEffect className={css.rankGlass}>
            <div className={css.rank}>
              <Icon type="rank-star" className={css.star} />
              <span className={css.points}>{user.points}</span>
              <div className={css.bg}></div>
            </div>
          </LiquidGlassEffect>
        </div>
      ) : (
        <LiquidGlassEffect>
          <Link to={LOGIN_ROUTE} className={css.signInBtn}>
            {_t('signIn')}
          </Link>
        </LiquidGlassEffect>
      )}
      <Link to={ROOT} className={css.logoLink} aria-hidden={hideLogo}>
        <Icon type="header-logo" />
      </Link>
    </header>
  );
}
